$(function() {
    // @vars -----------------------------------------------------------------------------------------------------------
    var $btn_show = $('.emergency-show');
    var $btn_hide = $('.emergency-hide');
    var $dialog = $('#modal-dialog-emergency');

    // @initialization -------------------------------------------------------------------------------------------------
    if ($dialog.length) {
        $dialog.modal({
            show: true,
            keyboard: false
        });
    }

    // @functions ------------------------------------------------------------------------------------------------------
    function sendData(data) {
        return $.ajax({
            url: '/' + BB_DIR_WEBROOT + '/index.php/tools/packages/emergency/ajax.php',
            data: data,
            type: 'GET',
            dataType: 'html'
        });
    }

    // @event listeners ------------------------------------------------------------------------------------------------
    $btn_show.on('click', function() {});
    $btn_hide.on('click', function() {});
    $dialog.on('hidden.bs.modal', function() {
        sendData({
            action: 'hide modal dialog emergency'
        });
    });


    $(document).on('click', '.close-dialog-emergency', function(e) {
        var href = $(this).attr('href');

        e.preventDefault();
        sendData({
            action: 'hide modal dialog emergency'
        }).done(function() {
            window.location = href;
        });
    });
});
